import { useEffect, useRef } from 'react'

import { IOptions } from './index'
import drawComparisonBarChart from './web/drawComparisonBarChart'

interface IProps {
  xAxisData: any[]
  dataset1Data: number[]
  dataset2Data: number[]
  options: IOptions
}

function Main({ xAxisData, dataset1Data, dataset2Data, options }: IProps) {
  const comparisonBarChartCanvasRef = useRef(null)

  useEffect(() => {
    let comparisonBarChart: any = null
    const comparisonBarChartCanvas: any = comparisonBarChartCanvasRef.current
    const comparisonBarChartCanvasContext =
      comparisonBarChartCanvas.getContext('2d')

    comparisonBarChart = drawComparisonBarChart(
      comparisonBarChartCanvasContext,
      xAxisData,
      dataset1Data,
      dataset2Data,
      options,
    )

    return () => {
      if (comparisonBarChart) {
        comparisonBarChart.destroy()
      }
    }
  }, [xAxisData, dataset1Data, dataset2Data, options])

  return (
    <div>
      <canvas
        ref={comparisonBarChartCanvasRef}
        width={options.width || 1200}
        height={options.height || 400}
      />
    </div>
  )
}

export default Main
